export * from './EtiquetaDePrecoServiceAdapter'